import React, { useEffect, useState } from "react";
import { getAllPublicFaqs } from "../../../services/publicService";

const Faq = ({ id }) => {
  const [expandedQuestion, setExpandedQuestion] = useState(null);
  const [faqData, setFaqData] = useState([]);

  useEffect(() => {
    fetchFaqs();
  }, [id]);

  async function fetchFaqs() {
    const data = await getAllPublicFaqs(id);

    if (Array.isArray(data)) {
      setFaqData(data);
    }
  }

  const toggleQuestion = (questionId) => {
    setExpandedQuestion(expandedQuestion === questionId ? null : questionId);
  };

  return (
    <section className="faq-wrapper">
      <div className="faq-header">
        <h2>Frequently Asked Questions</h2>
        <p>Find answers to common questions.</p>
      </div>

      <div className="faq-container">
        <div className="faq-list">
          {faqData.map((faq) => (
            <div className="faq-item" key={faq.id}>
              <button
                className="faq-question"
                onClick={() => toggleQuestion(faq.id)}
              >
                <span className="question-text">{faq.question}</span>

                <span
                  className={`arrow ${
                    expandedQuestion === faq.id ? "rotate" : ""
                  }`}
                >
                  <i className="fa fa-chevron-down"></i>
                </span>
              </button>

              {expandedQuestion === faq.id && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
